import { ChevronDown, XIcon } from 'lucide-react';
import { Icon, Typography } from '@/components/common';
import Icons from '@/const/icons';
import * as React from 'react';
import { FinishChartModal } from './FinishChatModal';

interface Props {
	toggle?: () => void;
	close?: () => void;
	from?: string;
	chatMessages: any[];
}

export const HeaderChat: React.FC<Props> = ({
	toggle,
	close,
	chatMessages,
}) => {
	const [showDelete, setShowDelete] = React.useState<boolean>(false);

	return (
		<>
			<div className="flex items-center justify-between">
				<div className="flex items-center gap-2">
					<Typography type="bold-20" className="text-left">
						Claim <span className="text-primary">Chat</span>
					</Typography>
					<Icon src={Icons.wand} className="!h-5 !w-5 text-green-base" />
				</div>
				<div className="flex items-center gap-x-4">
					{toggle && (
						<button onClick={toggle}>
							<ChevronDown className={`h-5 w-5 shrink-0`} />
						</button>
					)}
					{close && (
						<button
							onClick={() => setShowDelete(true)}
							className={`${chatMessages.length <= 2 ? 'hidden' : 'block'}`}
						>
							<XIcon className={`h-5 w-5 shrink-0`} />
						</button>
					)}
				</div>
			</div>
			<FinishChartModal
				setShow={setShowDelete}
				show={showDelete}
				close={close}
			/>
		</>
	);
};
